import { Box, FormField, MultiSelect, SingleSelect, Text } from "designSystem/index";
import React, { FunctionComponent } from "react";
import { useCreateSharedDataSheetsStore } from "./CreateSharedDataSheetsWizardStore";
import { observer } from "mobx-react-lite";

const CreateSharedDataSheetsForm: FunctionComponent = observer(() => {
	const store = useCreateSharedDataSheetsStore();
	const {
		dataSheetOption,
		localizedDataSheetType,
		localizedProductType,
		localizedProductSource,
		productOptions,
		selectedProductOptions,
		selectedSourceOptions,
		sourceOptions,
	} = store;

	const isDisabledProductSource = sourceOptions.length <= 1;

	return (
		<Box
			ml={17}
			pt={3}
			px={12}
			textAlign="right"
		>
			<FormField
				control={(
					<MultiSelect
						disableClearable
						noChips
						onChange={store.onChangeProducts}
						options={productOptions}
						value={selectedProductOptions}
					/>
				)}
				fullWidth
				label={<Text semiBold text={localizedProductType} />}
				labelPlacement="start"
			/>
			<FormField
				control={(
					<MultiSelect
						disableClearable
						grouped
						noChips
						onValueChange={store.onChangeSources}
						options={sourceOptions}
						value={selectedSourceOptions}
					/>
				)}
				disabled={isDisabledProductSource}
				fullWidth
				label={<Text semiBold text={localizedProductSource} />}
				labelPlacement="start"
			/>
			<FormField
				control={(
					<SingleSelect
						options={[dataSheetOption]}
						value={dataSheetOption}
					/>
				)}
				disabled
				fullWidth
				label={<Text semiBold text={localizedDataSheetType} />}
				labelPlacement="start"
			/>
		</Box>
	);
});

export default CreateSharedDataSheetsForm;